import type { TypographyVariant } from "@mui/material";
import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { CeTextField } from "../generic/components/form-fields/ce-text-field";

export const EditableField: FC<{
  title: string;
  editable: boolean;
  setEditable: (state: boolean) => void;
  setFilename: (f: string) => void;
  onChange?: (value: string) => void;
  error?: string;
  variant?: TypographyVariant;
  fontWeight?: number;
  textColor?: string;
  editableOnClick?: boolean;
  titleStyle?: React.CSSProperties;
}> = ({
  title,
  editable,
  error,
  setEditable,
  setFilename,
  onChange,
  variant,
  fontWeight,
  textColor,
  editableOnClick = true,
  titleStyle,
}) => {
  return (
    <Box sx={{ flexGrow: 1, position: "relative" }}>
      {!editable && (
        <Typography
          style={titleStyle}
          variant={variant ?? "h5"}
          fontWeight={fontWeight}
          color={textColor ?? "text.secondary"}
          onClick={() => {
            editableOnClick && setEditable(true);
          }}
        >
          {title}
        </Typography>
      )}

      {(editable || error) && (
        <CeTextField
          data-testid="edit-content-edit-name-input"
          sx={{
            color: "text.secondary",
            maxWidth: "360px",
            width: "100%",
          }}
          fullWidth
          variant="editabletext"
          defaultValue={title}
          error={Boolean(error)}
          helperText={error}
          onBlur={(e) => {
            if (e.target.value.trim() === "") {
              setEditable(false);
              return;
            }
            setFilename(e.target.value);
            e.target.value !== title && void onChange?.(e.target.value);
            setEditable(false);
          }}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.key === "Escape") {
              setEditable(false);
            }
          }}
          onKeyUp={(e) => {
            e.stopPropagation();
          }}
        />
      )}
    </Box>
  );
};
